import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import * as api from './networking'
import { Loader } from 'shared/components/preloader-animation'
import LeaderBoardGraph from './leader-board-graph'
import DashboardUserContext from '../../../site/dashboard/context'
import { mobile } from 'shared/util/media-query'


const LeaderboardContainer = styled.div`
    margin-top: 50px;
    margin-bottom: 40px;

    h1 {
        font-size: 24px;
        font-family: NexaBlack;
        margin-bottom: 10px;
        text-align: left;

        ${mobile.css`
            font-size: 18px;
        `}
    }
`

type Props = {
    contentType: string
    dateRange: any[]
    datePreset: 'ALL_TIME' | 'CUSTOM' | 'WEEK' | 'MONTH'
}

const LeaderBoard = ({ contentType, dateRange, datePreset }: Props) => {
    const { user } = useContext(DashboardUserContext)
    const [isFetching, setFetching] = useState(false)
    const [data, setData] = useState<api.LeaderboardItem[]>([])
    const [csv, setCsv] = useState('')
    const [csvCtr, setCsvCtr] = useState('')

    // If the date range or content types change, refresh the leaderboard.
    useEffect(() => {
        getLeaderboard()
    }, [dateRange, contentType])

    const getLeaderboard = async () => {
        const { token, username } = user
        const descendingOrder = ({ viewCount: viewCountA }, { viewCount: viewCountB }) => viewCountB - viewCountA
        setFetching(true)
        let data = await api.getLeaderboard(token, contentType, dateRange)
        data.sort(descendingOrder)
        setData(data)
        setCsv(api.getCsvLink(contentType, dateRange, username))
        setCsvCtr(api.getCsvCtrLink(contentType, dateRange, username))
        setFetching(false)
    }

    return (
        <LeaderboardContainer>
            <h1>Top {contentType}</h1>
            {isFetching ? (
                <Loader />
            ) : (
                <LeaderBoardGraph
                    data={data}
                    csv={csv}
                    csvCtr={csvCtr}
                    contentType={contentType}
                    dateRange={dateRange}
                    datePreset={datePreset}
                />
            )}
        </LeaderboardContainer>
    )
}

export default LeaderBoard
